const getResult = answers => {
  let lastAnswer = answers[answers.length - 1];
  let candidates = lastAnswer.question.results;
  let resultUrl = candidates[candidates.length - 1].url;
  for (let c of candidates) {
    let cAnswers = c.answer.split("-");
    let hit = true;

    answers = answers.slice(-cAnswers.length);

    for (let i = 0; i < answers.length; i++) {
      if (cAnswers[i] === "*") {
        continue;
      }

      // TODO: check why chatty need to use label as answer's value
      // when the question type is "select"
      let valueAfter = answers[i].question.choices.find(
        c => c.label === answers[i].value
      ).value;

      if (valueAfter.toString() !== cAnswers[i]) {
        hit = false;
        break;
      }
    }

    if (hit) {
      resultUrl = c.url;
      break;
    }
  }

  return resultUrl;
};

exports.getResultExt = getResult;
